export type TreeNodeItem = {
  path: string;
  key: string;
  label: string;
  selectable?: boolean;
  disabled?: boolean;
  hidden?: boolean;
  children?: string[];
  afterIcon?: string;
  beforeIcon?: string;
  raw?: any;
  tooltip?: string;
};

export type SortableTreeElement = {
  key: string;
  label: string;
  labelPath: string;
  path: string;
};

const numericPathCollator = new Intl.Collator(undefined, { numeric: true });

export function compareTreeElementsByPath(a: SortableTreeElement, b: SortableTreeElement): number {
  return numericPathCollator.compare(a.path, b.path) || a.label.localeCompare(b.label);
}
